<template>
  <div
    v-loading="isUploading"
    element-loading-text="上传中..."
  >
    <el-upload
      :id="id"
      ref="uploadComponent"
      action=""
      class="upload-demo"
      :file-name="fileName"
      :file-path="filePath"
      :limit="limitNum"
      :image-url="imageUrl"
      :multiple="isMultiple"
      :http-request="uploadImg"
      :before-remove="beforeRemove"
      :before-upload="beforeUpload"
      :on-exceed="handleExceed"
      :on-preview="onPreview"
      :show-file-list="showFileList"
      :file-list="fileList"
      :list-type="listType"
      :disabled="disabled"
      :on-remove="onRemove"
    >
      <i
        v-if="listType === 'picture-card'"
        class="el-icon-plus"
      />
      <el-button
        v-if="listType === 'text'"
        slot="trigger"
        size="small"
        type="primary"
        :disabled="disabled"
      >
        点击上传
      </el-button>
    </el-upload>
    <el-dialog
      :visible.sync="dialogVisible"
      append-to-body
    >
      <img
        width="100%"
        :src="dialogImageUrl"
        alt=""
      >
    </el-dialog>
  </div>
</template>
<script>
import AWconfig from '../../config/aliyun/AWconfig'
import Aliyun from '../../config/aliyun/aliyunConfig'
import Cookie from 'js-cookie'

export default {
  name: 'Upload',
  props: {
    limitNum: {
      type: Number,
      default: 1
    },
    isMultiple: {
      type: Boolean,
      default: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    listType: {
      type: String,
      default: 'picture-card'
    },
    id: {
      type: String,
      default: 'upload'
    },
    // upload做过一次修改,此参数为了兼容之前只返回数组的情况
    isNeedExpendInfo: {
      type: Boolean,
      default: false
    },
    // 必须是[{url:''}]格式
    imageUrl: {
      type: Array,
      default: () => {}
    },
    // 单张的情况可以用这个showFileList=false 这里在默认上传行为 的情况下直接将
    showFileList: {
      type: Boolean,
      default: true
    },
    // 传入文件的name和url字段
    fileName: {
      type: String,
      default: 'fileName'
    },
    filePath: {
      type: String,
      default: 'filePath'
    },
    fileSize: {
      type: Number,
      default: 10
    },
    // 是否检测文件的类型
    isCheckType: {
      type: Boolean,
      default: true
    },
    // 是否监听imgURL 弹框的情况
    isWatch: {
      type: Boolean,
      default: false
    },
    // 校验格式的正则
    fileType: {
      type: String,
      default: 'img'
    },
    isCanPreview: {
      type: Boolean,
      default: true
    },
    isUseAliyun: {
      type: Boolean,
      default: true
    },
    // 需要在disable为true情况下生效
    justLook: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      aliyun: '',
      fileList: [],
      dialogImageUrl: '',
      dialogVisible: false,
      isCheck: true,
      isUploading: false, // 图片是否上传中
      /**
       * 文件正则校验、文件提示文案、文件校验目标对象
       *  */
      fileObj: {
        'img': { reg: 'gif|jpg|jpeg|png|GIF|JPG|PNG$', hint: '上传的文件类型必须是gif、jpg、jpeg、png中的一种' },
        'excel': { reg: 'xls|xlsx$', hint: '上传的文件类型必须是xls或xlsx' }
      },
    }
  },
  computed: {
    token () {
      return this.$store.state.file.aliyunFileToken
    }
  },
  watch: {
    imageUrl (newVal, oldVal) {
      if (this.isWatch) {
        // imageUrl为数组情况
        if (newVal instanceof Array) {
          if (newVal.length !== oldVal.length) {
            this.getAllList()
          }
          // imageUrl为非数组情况
        } else {
          this.getAllList()
        }
      }
    },
    '$store.state.file.aliyunFileToken' (val) {
      if (val === null) {
        this.$message.error('阿里云服务token过期，请重试')
        this.isUploading = false
        this.$emit('returnFileInfo', [])
        this.clearFileList()
      }
    },
  },
  async created () {
    if (this.disabled || !this.isUseAliyun) {
      return
    }
    if (!this.$store.state.file.aliyunFileToken) {
      await this.$store.dispatch('retrieveToken')
    }
    this.setAliyunConfig(this.$store.state.file.aliyunFileToken)
  },
  mounted () {
    this.getAllList()
  },
  methods: {
    // 弹框的话不会进入mounted 所以需要手动抵用回显
    getAllList () {
      this.fileList = this.imageUrl
      this.returnFileInfo(this.fileList)
    },
    getFileList () {
      return this.fileList
    },
    async clearFileList () {
      this.fileList = []
      this.$refs.uploadComponent.clearFiles()
      this.$store.commit('setAliyunTokenCount', 0)
      await this.$store.dispatch('retrieveToken')
      this.setAliyunConfig(this.$store.state.file.aliyunFileToken)
    },
    onPreview (file) {
      if (!this.isCanPreview) return
      this.dialogImageUrl = file.url
      // 不校验格式的情况 可能是word pdf 提供下载打开功能
      this.isCheckType ? this.dialogVisible = true : window.open(file.url)
    },
    /**
     * 根据isNeedExpendInfo判断是否获取扩展信息
     * 上传证件信息的时候有很多个 这里根据id做一个封装 传入的id即为绑定的值字段
     * name为原本上传文件的名称  阿里云上传会重置名称
     *  */
    returnFileInfo (list) {
      this.isUploading = false
      this.controlShowOrHidden(list)
      if (this.isNeedExpendInfo) {
        this.$emit('returnFileInfo', {
          list: list,
          id: this.id,
        })
      } else {
        this.$emit('returnFileInfo', list)
      }
    },
    // 单张图片上传之后隐藏第二张
    controlShowOrHidden (fileList) {
      if ((this.limitNum > 1 && !this.disabled) || this.listType !== 'picture-card') {
        return
      }
      const uploadPlus = document.getElementById(this.id).lastChild
      // 如果只是查看直接隐藏后面的
      if (this.disabled && this.justLook) {
        uploadPlus.style.visibility = 'hidden'
        uploadPlus.style.display = 'none'
        return
      }
      // 单张图片上传处理
      if (fileList.length >= this.limitNum) {
        uploadPlus.style.visibility = 'hidden'
        uploadPlus.style.display = 'none'
      } else {
        uploadPlus.style.visibility = 'visible'
        uploadPlus.style.display = 'block'
      }
    },
    onRemove (file, fileList) {
      this.fileList = fileList
      this.returnFileInfo(this.fileList)
    },
    beforeRemove (file, fileList) {
      if (this.isCheck) {
        return this.$confirm(`确定移除该文件/图片吗？`)
      }
    },
    handleExceed (files, fileList) {
      this.$message.warning(
        `当前限制选择文件/图片数量为 ${this.limitNum} ，如果要修改文件，请先删除当前文件。`
      )
    },
    async beforeUpload (file) {
      // 阿里云上传图片token过期的话会把相应的cookie清空
      if (!Cookie.get('accessKeyId') && this.isUseAliyun) {
        this.isUploading = false
        // this.$message.error('阿里云上传文件/图片服务异常，请重试~')
        this.$store.commit('setAliyunTokenCount', 0)
        await this.$store.dispatch('retrieveToken')
        this.setAliyunConfig(this.$store.state.file.aliyunFileToken)
        this.isCheck = false
        // return Promise.reject(new Error('阿里云上传文件/图片Token过期'))
      }
      let fileObj = this.fileObj[this.fileType]
      let reg = new RegExp(fileObj.reg, 'ig')
      // 融资不需要校验类型 可能是文件也可能是图片
      const checkType = this.isCheckType ? reg.test(file.name) : true
      const checkSize = file.size / 1024 / 1024 < this.fileSize

      if (!checkType) {
        this.$message.error(fileObj.hint)
      }
      if (!checkSize) {
        this.$message.error('上传的文件/图片大小不能超过' + this.fileSize + 'MB!')
      }
      this.isCheck = checkType && checkSize
      this.isUploading = true

      return new Promise((resolve, reject) => {
        checkType && checkSize ? resolve() : reject(new Error('上传的文件/图片过大'))
      })
    },
    // 自定义上传方法
    async uploadImg (param) {
      if (this.isUseAliyun) {
        this.isUploading = true
        this.setAliyunConfig(this.$store.state.file.aliyunFileToken)
        // 有可能cookie过期，需要捕捉错误重新获取token
        try {
          let fn = (url, aliyunResult, event) => {
            this.fileList.push({ name: param.file.name, url: url })
            this.returnFileInfo(this.fileList)
          }
          this.aliyun(fn, param.file)
        } catch (err) {
        // 过期的情况
          this.isUploading = false
          this.$store.commit('setAliyunFileToken', null)
          Cookie.remove('accessKeyId')
          Cookie.remove('accessKeySecret')
          Cookie.remove('securityToken')
        }
      } else {
        this.isUploading = false
        this.returnFileInfo(param.file)
      }
    },
    // 配置阿里云
    setAliyunConfig (token) {
      if (!this.$store.state.file.aliyunFileToken) {
        return
      }
      this.aliyun = new Aliyun().config({
        AWconfig: AWconfig,
        token: token
      })
    },
  }
}
</script>
<style scoped>
  .avatar-uploader .el-upload {
    position: relative;

    overflow: hidden;

    cursor: pointer;

    border: 1px dashed #d9d9d9;
    border-radius: 6px;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409eff;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    line-height: 178px;

    width: 178px;
    height: 178px;

    text-align: center;

    color: #8c939d;
  }
  .avatar {
    display: block;

    width: 178px;
    height: 178px;
  }
</style>
